export class FinanceInventory {
  id: any;
  periodId: any;
  partnerId: any;
  status: any;
}
